import { html, View } from 'rune-ts';
import { PhotoReviewTypeS } from '../../../../../features/PhotoReview/outbound/share';
import { PhotoReviewCard } from '../../../../components/cells/PhotoReviewCard/PhotoReviewCard';
import { LegacySectionTitleProps } from '../LegacySectionTitle/LegacySectionTitle';
import klass from './PhotoReview.module.scss';
import { SectionTitle } from '@services/MarppleShop/renderApp/components/cells/SectionTitle/SectionTitle';
import { SeeMoreLinkPlugin } from '@services/MarppleShop/renderApp/components/cells/SectionTitle/plugins';

export type PhotoReviewProps = {
  section_title: LegacySectionTitleProps;
  reviews: PhotoReviewTypeS.PhotoReviewCardType[];
  is_mobile: boolean;
};

export class PhotoReview extends View<PhotoReviewProps> {
  override template() {
    const { reviews } = this.data;

    return html`<div class="${klass.container}">
      <div class="${klass.title_wrap}">
        ${new SectionTitle({
          title_props: {
            title: this.data.section_title.title,
            size: this.data.is_mobile ? 'large' : 'xLarge',
          },
          plugins: [
            new SeeMoreLinkPlugin({
              navigate: this.data.section_title.navigate,
              see_more_link: this.data.section_title.see_more_link,
              size: this.data.is_mobile ? 'xSmall' : 'medium',
            }),
          ],
        })}
      </div>
      <div class="${klass.review_list}">${reviews.map((review) => new PhotoReviewCard(review))}</div>
    </div> `;
  }
}
